module.exports = __webpack_public_path__ + "static/img/iphone1.c7b9ba7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/iphone1.png
// module id = /Uuf
// module chunks = 1